import { DI } from "../../infrastructure/di";
import { AssetLoaderComponent } from "../components/microservice/asset-loader-component";
import { HtmlLoaderComponent } from "../components/microservice/html-loader-component";
import { HtmlValidatorComponent } from "../components/microservice/html-validator-component";
import { ManifestLoaderComponent } from "../components/microservice/manifest-loader-component";
import { ManifestValidatorComponent } from "../components/microservice/manifest-validator-component";
import { ITracker } from "../interfaces/tracker.interface";
import { BobRequest } from "../model/bob-request";
import { Microservice } from "../model/microservice";
import { MicroservicePipeline } from "../pipelines/microservice-pipeline";
import { IPipeline } from "../pipelines/pipeline.inferface";
import { TracingComponent } from "../pipelines/tracing-component";
import { TrackingMicroservicePipeline } from "../pipelines/tracking-microservice-pipeline";
import { HtmlRepository } from "../repositories/html-repository";
import { ManifestRepository } from "../repositories/manifest-repository";
import { TracingClassFactory } from "./tracing-class-factory";

export class MicroservicePipelineFactory {

	private readonly tracker: ITracker;
	private tracingClassFactory = new TracingClassFactory();
	private microserviceLoaderTracingComponent: TracingComponent<BobRequest, BobRequest>;

	constructor(microserviceLoaderTracingComponent: TracingComponent<BobRequest, BobRequest>, tracker: ITracker) {

		this.microserviceLoaderTracingComponent = microserviceLoaderTracingComponent;
		this.tracker = tracker;
	}

	public create(): IPipeline<Microservice, Promise<Microservice>> {

		const htmlRepository: HtmlRepository = DI.container.get(DI.HTML_REPOSITORY);
		const manifestRepository: ManifestRepository = DI.container.get(DI.MANIFEST_REPOSITORY);

		const manifestLoader = new ManifestLoaderComponent(manifestRepository, this.tracker);
		const manifestValidator = new ManifestValidatorComponent(this.tracker);
		const htmlLoader = new HtmlLoaderComponent(htmlRepository, this.tracker);
		const htmlValidator = new HtmlValidatorComponent(this.tracker);
		const assetLoader = new AssetLoaderComponent(this.tracker);

		const parentSegment = this.microserviceLoaderTracingComponent.getSegment();
		const segment = parentSegment.addNewSubsegment("MicroservicePipeline");

		const microservicePipeline = new MicroservicePipeline(
			this.tracingClassFactory.createTracingComponent(segment, manifestLoader),
			this.tracingClassFactory.createTracingComponent(segment, manifestValidator),
			this.tracingClassFactory.createTracingComponent(segment, htmlLoader),
			this.tracingClassFactory.createTracingComponent(segment, htmlValidator),
			this.tracingClassFactory.createTracingComponent(segment, assetLoader)
		);

		const trackingMicroservicePipeline = new TrackingMicroservicePipeline(
			microservicePipeline,
			this.tracker
		);

		return this.tracingClassFactory.createTracingPipeline(
			segment,
			trackingMicroservicePipeline
		);
	}
}
